import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.reports-sharing-center', {
        url: '/reports/sharing-center',
        component: 'sharingCenterReport',
        resolve: {sharedAccounts}
    });
}


/** @ngInject */
function sharedAccounts( companyId, SharedAccountsService) {
    return SharedAccountsService
        .getAllSharedReportByCompany({companyId}).$promise;

}


// WEBPACK FOOTER //
// ./src/portal/states/company/reports/sharing-center-reports/sharing-center-reports.state.js